import { piniaOfficeOffer } from '@stores/useOfficeOfferStore';
import { createApp } from 'vue';
import OfficeChooser from '@pages/offer-page/office-chooser/OfficeChooser.vue';

export const officeChooser = () => {
  if (!document.getElementById('multioffice-modal-app')) {
    return;
  }

  const app = createApp(OfficeChooser);

  app.config.globalProperties.$companyName = window.COMPANY_NAME;

  app.use(piniaOfficeOffer);
  app.mount('#multioffice-modal-app');
};
